import Zendesk from '@dansmaculotte/vue-zendesk'

export default ({ app, router, Vue }) => {
	Vue.use(Zendesk, {
        key: process.env.ZENDESK_KEY,
        disabled: true,
        hideOnLoad: false
    })
}
